export function buildAddress({
  firstLine,
  secondLine,
  city,
  state,
  pincode,
}: {
  firstLine: string;
  secondLine?: string;
  city: string;
  state: string;
  pincode: string;
}) {
  let addressLine = "";
  if (
    firstLine &&
    firstLine.trim() !== "" &&
    secondLine &&
    secondLine.trim() !== ""
  ) {
    addressLine = `${firstLine} ${secondLine}`;
  } else if (firstLine) {
    addressLine = firstLine;
  } else if (secondLine) {
    addressLine = secondLine;
  }
  const parts = [addressLine, city, state, pincode];
  const nonEmptyParts = parts.filter((part) => part && part.trim() !== "");
  return nonEmptyParts.join(", ");
}

export const formatCurrency = (amount: number | null | undefined): string => {
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  });

  return formatter.format(amount ?? 0);
};

export function convertToQueryString(params: Record<string, any>): string {
  const queryParts: string[] = [];

  for (const key in params) {
    if (Array.isArray(params[key])) {
      params[key].forEach((value: string) => {
        queryParts.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        );
      });
    } else {
      queryParts.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      );
    }
  }

  return queryParts.join("&");
}

export function getUrlWithCustomFilters(
  defaultParams: Record<string, any>,
  defaultEndpoint: string,
  customFilters?: Record<string, any>,
  customEndpoint?: string,
  additionalParams?: Record<string, any>
): string {
  const finalParams = {
    ...defaultParams,
    ...(customFilters || {}),
    ...additionalParams,
  };
  const queryString = convertToQueryString(finalParams);
  const endpoint = customEndpoint || defaultEndpoint;
  return `${endpoint}?${queryString}`;
}

export function buildCptSlabLevelParams(
  activeTab?: string,
  existingParams?: Record<string, any>
): Record<string, string | string[]> {
  const hasExplicit = !!existingParams?.cptSlabLevel;
  if (hasExplicit || !activeTab) return {} as Record<string, string | string[]>;
  
  return {
    cptSlabLevel: [activeTab],
  }
}

export function cleanPhoneNumber(phoneNumber: string): string {
  let digits = phoneNumber.replace(/\D/g, "");
  if (digits.startsWith("91") && digits.length > 10) {
    digits = digits.slice(digits.length - 10);
  }
  digits = digits.slice(-10);
  return digits;
}

export function isMobileConfigFlagEnabled(
  value: unknown,
  defaultWhenMissing = false,
): boolean {
  if (value == null || value === "") {
    return defaultWhenMissing;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true" || normalized === "1" || normalized === "yes") {
      return true;
    }
    if (normalized === "false" || normalized === "0" || normalized === "no") {
      return false;
    }
  }

  if (typeof value === "number") {
    if (value === 1) {
      return true;
    }
    if (value === 0) {
      return false;
    }
  }

  return defaultWhenMissing;
}